import axios, {AxiosInstance, AxiosPromise} from 'axios';

import buildPaginationQueryOpts from '@/shared/sort/sorts';

import { IReports } from '@/shared/model/reports.model';

const baseApiUrl = 'api/reports';

export default class ReportsService {
  private axios: AxiosInstance;

  constructor() {
    this.axios = axios;
  }

  public find(id): Promise<IReports> {
    return new Promise<IReports>(resolve => {
      axios.get(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public retrieve(paginationQuery?: any, search?: IReports ): Promise<any> {
    return new Promise<any>((resolve,reject) => {
      let url = `${baseApiUrl}?`;
      if (search.product) {
        url = `${url}product.contains=${search.product}&`;
      }

      if (search.customer) {
        url = `${url}customer.contains=${search.customer}&`;
      }

      if (search.vendorName) {
        url = `${url}vendorName.contains=${search.vendorName}&`;
      }

      if (search.licenseId) {
        url = `${url}license.contains=${search.licenseId}&`;
      }

      if (search.sender) {
        url = `${url}sender.contains=${search.sender}&`;
      }

      if (search.version) {
        url = `${url}version.contains=${search.version}&`;
      }

      if (search.id) {
        url = `${url}id.equals=${search.id}&`;
      }

      if (search.search) {
        url = `${url}search.contains=${search.search}&`;
      }
      axios.get(url + `${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      }).catch(err => {
        reject(err);
      });
    });
  }

  public delete(id): Promise<any> {
    return new Promise<any>(resolve => {
      axios.delete(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public create(entity): Promise<IReports> {
    return new Promise<IReports>(resolve => {
      axios.post(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public update(entity): Promise<IReports> {
    return new Promise<IReports>(resolve => {
      axios.put(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public downloadReportData(id): AxiosPromise<any> {
      return axios.get(`${baseApiUrl}/download?reportId=${id}`);
  }

  public downloadReportDataForPeriod(id, year, month, period): AxiosPromise<any> {
      return axios.get(`/api/rums/revenue/downloadForPeriod?installationId=${id}&year=${year}&month=${month}&period=${period}`);
  }
}
